import { httpGet, httpPost, urlConcat } from '@/utils/http'
import {getArrayFromString, treeToString, isNullFalse, convertOrganizationLevels, parseKey} from "@/utils/converter";
import { concat, concatEnding, concatTitle } from "@/utils/str";
import {camelKeys, lowerKeys, toArray} from "@/utils/obj";
import {authToken} from '@/store';
import { API_ORDER, API_TENDER, USE_CREDENTIALS} from '@/config'

export async function setOrderIsViewed(id) {
  return await httpPost(urlConcat(API_ORDER, '/api/order/SetOrderIsViewed'), {
    OrderId: id,
    Token : authToken()
  });
}

export async function getFilters() {
  return await httpPost(urlConcat(API_ORDER, '/api/order/GetFilters'), {
    Token: authToken()
  });
}

export async function cancelExpiredOrders() {
  return await httpPost(urlConcat(API_ORDER, '/api/order/CancelExpiredOrders'), {
    Token: authToken()
  });
}

export async function getTendersByTags(status, tagIds, isFirstLoad, isLoadFromTr, lastVisibleOrderId, filterType) {
  return await httpPost(urlConcat(API_ORDER, '/api/order/GetTendersByTags'), {
    Status: status,
    TagIds: tagIds,
    IsFirstLoad: isFirstLoad,
    IsLoadFromTr: isLoadFromTr,
    LastVisibleOrderID: lastVisibleOrderId,
    FilterType: filterType,
    Token: authToken()
  });
}

export async function getTender(id) {
  let data = await httpPost(urlConcat(API_ORDER, '/api/order/GetTender'), {
    TenderId: id,
    Token: authToken()
  });

  return data;
}

export async function getTenderAnalytics(id) {
  return await httpPost(urlConcat(API_ORDER, '/api/order/GetTenderAnalytics'), {
    TenderId: id,
    Token: authToken()
  });
}

function snippetCodeToName(k, sc) {
  let name = k;
  if (k === 'tradename') name = sc === 2 ? 'Наименование плана' : 'Наименование тендера';
  else if (k === 'itemsitemname' || k === 'items.itemName') name = sc === 2 ? 'Закупаемая продукция' : 'Позиция лота';
  else if (k === 'lotname') name = sc === 2 ? 'Наименование позиции плана' : 'Наименование лота';
  else if (k === 'kladrdeliveryregionname') name = 'В адресе поставки';
  else if (k === 'kladrregionname') name = 'В адресе заказчика';
  else if (k === 'itemsitemokpd2name') name = 'Код ОКПД2';

  return name;
}

export function mapSnippetsFromTender(tender) {
  if (!tender) return [];

  if (Array.isArray(tender))
    if (tender.length > 0) tender = tender[0];
    else return [];

  tender = lowerKeys(tender);
  let highlight = tender.highlight;
  let contents = tender.contents;
  let itemsHighlights = tender.itemshighlights;
  let tenderItems = tender.tenderitems;
  let foundInContents = tender.foundincontents;
  let salesChannel = tender.saleschannel;

  let nextHighlight = [];

  if (highlight) {
    let keys = Object.keys(highlight);
    keys.forEach(k => {
      let vls = highlight[k];
      if (vls && vls.length > 0) {
        vls.forEach(vl => {
          let name = snippetCodeToName(k, salesChannel);
          nextHighlight.push({name, text: vl, key: k});
        })
      }
    });
  }

  if (itemsHighlights && itemsHighlights.length > 0) {
    itemsHighlights.forEach(item => {
      let index = item.index;
      let hglt = item.highlight;
      if (hglt) {
        let keys = Object.keys(hglt);

        keys.forEach(k => {
          let name = snippetCodeToName(k, salesChannel);
          if (k === 'itemsitemokpd2name') {
            let number = null;
            if (index >= 0) number = `${index + 1}`;
            name = concat(' ', ['В коде ОКПД2', concatTitle(salesChannel === 2 ? 'объекта закупки ' : 'позиции лота ', number)]);
          }
          else if (k === 'itemsitemname') {
            let nameEnding = `${index + 1}`;
            name = concatEnding(name, concatTitle(' ', nameEnding));
          }

          let vls = hglt[k];
          if (vls && vls.length > 0) {
            vls.forEach(vl => {
              nextHighlight.push({name, text: vl, key: k});
            })
          }
        })
      }
    })
  }

  //подсказки по документам должны идти последними
  if (contents && contents.length > 0) {
    contents.forEach(content => {
      if (content) {
        let source = content.source;

        let name = source.name;
        let url = source.url;
        let text = null;

        //FoundInContents
        if (content && content.highlight && content.highlight.contents && content.highlight.contents.length > 0) {
          text = content.highlight.contents;

          nextHighlight.push({name: 'Документ', text, linkText: name, link: url});
        } else {
          if (foundInContents) {
            if (tender.state === 3)
              text = "Документы тендера. <span style='font-style: italic'>В связи с тем, что тендер является архивным, отсутствует возможность отображения найденного совпадения. Скачайте документы для более подробного ознакомления.</span>";
            else
              text = "Документы тендера. <span style='font-style: italic'>Отсутствует возможность отобразить найденные совпадения. Скачайте документы для более подробного ознакомления.</span>";

            nextHighlight.push({name: 'Документ', text, linkText: name, link: url});
          }
        }
      }
    });
  }

  return nextHighlight;
}

export async function getSnippets({id, keywordsList, tagId}) {
  if (!(keywordsList && keywordsList.length > 0 || tagId) || !id) return null;

  let url = urlConcat(API_ORDER, '/api/order/Search');

  let body = {
    "filter_settings": {
      "keywords_list": keywordsList,
      "id": id,
      "tag_id": tagId,
      "is_doc_search": true
    },
    "securityToken": authToken()
  };

  let data = await httpPost(url, body);
  if (data && data.Result && data.Result.Tenders && data.Result.Tenders.length > 0) {
    let highlight = mapSnippetsFromTender(data.Result.Tenders);
    return highlight;
  }

  return null;
}

export async function setOrderInWork(id) {
  await httpPost(urlConcat(API_ORDER, "/api/order/SetOrderInWork"), {
    OrderId: id,
    Token: authToken()
  });
}

export async function setOrderCancelled(id) {
  await httpPost(urlConcat(API_ORDER, "/api/order/SetOrderCancelled"), {
    OrderId: id,
    Token: authToken()
  });
}

export async function setOrderCompleted(id) {
  await httpPost(urlConcat(API_ORDER, "/api/order/SetOrderCompleted"), {
    OrderId: id,
    Token: authToken()
  });
}

export async function setOrderDeleted(id, reason) {
  await httpPost(urlConcat(API_ORDER, "/api/order/SetOrderCancelled"), {
    OrderId: id,
    Reason: reason,
    Token: authToken()
  });
}

export async function recoveryToWork(id) {
  await httpPost(urlConcat(API_ORDER, "/api/order/RecoveryToWork"), {
    OrderId: id,
    Token: authToken()
  });
}

export async function getOrderByTenderId(tenderId, salesChannel) {
  return await httpPost(urlConcat(API_ORDER, '/api/order/GetOrderByTenderId'), {
    TenderId: tenderId,
    SalesChannel: salesChannel,
    Token: authToken()
  });
}

export async function createManualOrder(tenderId, salesChannel) {
  return await httpPost(urlConcat(API_ORDER, '/api/order/CreateManualOrder'), {
    TenderId: tenderId,
    SalesChannel: salesChannel,
    Token: authToken()
  });
}

export async function getEtpLink(marketPlaceId, organizationLevel, purchaseMethod, registrationNumber) {
  let data = await httpPost(urlConcat(API_ORDER, "/api/order/GetEtpHelpLink"), {
    MarketPlaceId: marketPlaceId,
    TenderOrganizationLevel: organizationLevel,
    PurchaseMethod: purchaseMethod,
    Number: registrationNumber,
    Token: authToken()
  });

  return data;
}

export async function setEtpLinkViewMode(etpLinkId) {
  await httpPost(urlConcat(API_ORDER, "/api/order/setEtpLinkViewMode"), {
    Id: etpLinkId,
    Token: authToken()
  });
}

export async function setFilter(filter) {
  let color = filter && filter.color && filter.color.backgroundColor;
  let maxOrdersCount = filter && filter.maxOrdersCount;
  let filterData = {...filter, colorNumber: color, maxOrdersCount: maxOrdersCount, securityToken : authToken()};
  if (!filterData.name) filterData.name = 'Новый мониторинг';

  return httpPost(urlConcat(API_ORDER, "/api/order/SetFilter"), filterData);
}

export async function removeFilter(tagId) {
  await httpPost(urlConcat(API_ORDER, "/api/order/RemoveFilter"), {
    Id: tagId,
    SecurityToken: authToken()
  });
}

export async function getCounters(params) {
  if (!params || params.length <= 0) return null;

  let url = urlConcat(API_ORDER, '/api/order/GetCounters2');
  let data = await httpPost(url, params);

  data = camelKeys(data);
  return data;
}

export async function search(filter, pageSettings, salesChannel) {
  if (!filter) return [];
  if (!filter.currencyCode) filter.currencyCode = null;

  filter = {...filter};

  pageSettings = {
    sorting_field: 'DatePublished',
    sorting_direction: 'Desc',
    page_size: 20,
    page_index: 1,
    ...pageSettings,
  };

  const isSubcontract = salesChannel === 3;

  let regions = isSubcontract ? filter.deliveryRegion : filter.universalRegion;
  let regionsKeysObjects = regions && regions.map(parseKey);
  let prepareRegions = regionsKeysObjects && treeToString(regionsKeysObjects.filter(a => a.level !== 3)) || null;


  let universalRegion = null;
  let deliveryRegion = null;
  if (isSubcontract) deliveryRegion = prepareRegions;
  else universalRegion = prepareRegions;

  let deliveryCity = regionsKeysObjects && treeToString(regionsKeysObjects.filter(a => a.level === 3)) || null;


  let organizerInfo = filter.organizerInfo;
  if (organizerInfo && organizerInfo.length <= 0) organizerInfo = null;
  if (organizerInfo && organizerInfo.length > 0) organizerInfo = organizerInfo.map(a => a.innKpp).find(a => a);

  let customerInfo = filter.customerInfo;
  if (customerInfo && customerInfo.length <= 0) customerInfo = null;
  if (customerInfo && customerInfo.length > 0) customerInfo = customerInfo.map(a => a.innKpp).find(a => a);


  let organizationsTags = filter.organizationsTags;
  if (organizationsTags && organizationsTags.length > 0) {
    organizationsTags = organizationsTags.map(aa => {
      let nextAa = {};

      if (aa.id) nextAa.id = aa.id.trim();
      if (aa.inn) nextAa.inn = aa.inn.trim();
      if (aa.innKpp) nextAa.innKpp = aa.innKpp.trim().replace(/\s+/g, '_');
      if (aa.kpp) nextAa.kpp = aa.kpp.trim();
      if (aa.name) nextAa.name = aa.name.trim();

      return nextAa;
    });
  }

  let body = {
    filter_settings: {
      //id: filter.id,
      isPersonal: true,
      state: filter.state,
      keywords_list: filter.keywords,
      exclude_keywords_list: filter.excludeKeywords,
      universal_region: universalRegion,
      delivery_city: deliveryCity,
      delivery_region: deliveryRegion,
      okpd2: treeToString(filter.okpd2),
      is_doc_search: filter.documentSearchEnabled,
      purchase_methods: getArrayFromString(filter.purchaseMethods),
      min_price: filter.minPrice,
      max_price: filter.maxPrice,
      currency_code: filter.currencyCode,
      min_application_guarantee: filter.minApplicationGuarantee,
      max_application_guarantee: filter.maxApplicationGuarantee,
      min_contract_guarantee: filter.minContractGuarantee,
      max_contract_guarantee: filter.maxContractGuarantee,
      prepayment: filter.hasPrepayment,
      has_applications: filter.hasApplications,
      organization_levels: getArrayFromString(filter.organizationLevels),
      isApplicationWithoutSignatureAllowed: isNullFalse(filter.isAvailableApplicationsWithoutSignature),
      section_ids: filter.sectionIds,
      //customer_info: null,
      //organizer_info: null,
      organizationsTags,
      is_msp: filter.isSmallAndAverageBusiness,
      publish_date_from: filter.datePublishedFrom,
      publish_date_to: filter.datePublishedTo,
      aplication_end_date_from: filter.applicationEndDateFrom,
      aplication_end_date_to: filter.applicationEndDateTo,
      //trade_number: null, не надо
      //tender_id: null, не надо
      //trade_registration_number: null, не надо
      combinedTradeRegistrationNumber: filter.combinedTradeRegistrationNumber,
      sales_channels: toArray(filter.salesChannel),
      publication_date_period: filter.publicationDatePeriod,
      organizer_info: organizerInfo,
      customer_info: customerInfo,
      region: treeToString(filter.region),
    },
    page_settings: pageSettings,
    securityToken: authToken(),
    saveToHistory: filter.saveToHistory,
  };

  return await httpPost(urlConcat(API_ORDER, '/api/order/Search'), body, {withCredentials: USE_CREDENTIALS});
}

export async function getFiltersWithStats(salesChannel) {
  let token = authToken();
  if (token){
    let data = await httpGet(urlConcat(API_ORDER, '/api/order/GetUserSearchInfo'),
      {
        param: {
          salesChannels: toArray(salesChannel),
          securityToken: token
        },
      }
    );

    let result = {
      filters: [],
      searchHistory: []
    };

    if (data && data.IsSuccess){
      data.Filters.forEach(function (item) {
        result.filters.push({...item.Filter, total: item.TendersCount});
      });

      data.SearchItems.forEach(function (item) {
        result.searchHistory.push({id: item.Id, name: item.Keywords, keywords: [item.Keywords]});
      });
    }

    return result;
  }

  return [];
}

export async function getSearchHistory(salesChannel) {
  let token = authToken();
  if (token){
    let data = await httpGet(urlConcat(API_ORDER, '/api/order/GetSearchHistory'),
      {
        param: {
          salesChannels: toArray(salesChannel),
          securityToken: token
        },
      }
    );

    data = camelKeys(data);
    return data;
  }

  return [];
}

export async function getColorsForFilters() {
  let data = await httpGet(urlConcat(API_ORDER, "/api/order/GetColorsForFilters"), {
    SecurityToken: authToken()
  });

  return data;
}

export async function getDayAverageTendersCountAndSumForFilter(filterId) {
  let data = await httpGet(urlConcat(API_ORDER, "/api/order/GetDayAverageTendersCountAndSumForFilter"), {
    Id: filterId,
    SecurityToken: authToken()
  });

  return data;
}

export async function getOkpd2Json() {
  let data = await httpGet(urlConcat(API_ORDER, "/api/order/GetOkpd2Json"));
  return data;
}

export async function logView(tenderId) {
  let params = {tenderId: tenderId, securityToken: authToken()};
  let data = await httpPost(urlConcat(API_ORDER, "/api/order/LogView"), params);
  return data;
}

export async function logDownload(id, salesChannel) {
  let params = {id: id, salesChannel: salesChannel, securityToken: authToken()};
  let data = await httpPost(urlConcat(API_ORDER, "/api/order/LogDownloadFile2"), params);
  return data;
}

export async function getTagsByOrderId(orderId) {
  let body = {OrderId: orderId, Token: authToken()};
  let data = await httpPost(urlConcat(API_ORDER, "/api/order/GetTagsByOrderId"), body);
  return data;
}

export default {
  setOrderIsViewed,
  getFilters,
  cancelExpiredOrders,
  getTendersByTags,
  getTender,
  getTenderAnalytics,
  setOrderInWork,
  setOrderCancelled,
  setOrderCompleted,
  setOrderDeleted,
  recoveryToWork,
  getOrderByTenderId,
  createManualOrder,
  getEtpLink,
  setEtpLinkViewMode,
  setFilter,
  removeFilter,
  search,
  getFiltersWithStats,
  getColorsForFilters,
  getDayAverageTendersCountAndSumForFilter,
  getOkpd2Json,
  logView,
  logDownload,
  getSnippets,
  getTagsByOrderId,
  getCounters
};
